/**
 * Saved Filters State
 * Manages user's saved filter configurations across all views
 */

export default {
  // Array of saved filter objects
  filters: [],

  // Loading state
  loading: false,

  // Error state
  error: null,

  // Currently active filter ID (for UI highlighting)
  activeFilterId: null,
}
